import React, { useRef, useEffect, useState } from "react";
import { Button } from "./ui/button";

export default function SignaturePad({ value, onChange }) {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [mode, setMode] = useState("draw"); // draw | type
  const [typedName, setTypedName] = useState("");

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "rgba(0,0,0,0)";
    ctx.clearRect(0, 0, c.width, c.height);
  }, []);

  const getPos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    return { x: x * (canvasRef.current.width / rect.width), y: y * (canvasRef.current.height / rect.height) };
  };

  const start = (e) => {
    e.preventDefault();
    setDrawing(true);
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = getPos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const draw = (e) => {
    if (!drawing) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = getPos(e);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#534AB7";
    ctx.lineTo(x, y);
    ctx.stroke();
  };
  const end = () => {
    setDrawing(false);
    if (canvasRef.current) onChange?.(canvasRef.current.toDataURL("image/png"));
  };

  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    onChange?.(null);
  };

  const applyTyped = () => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);
    ctx.fillStyle = "#534AB7";
    ctx.font = "italic 36px 'Outfit', cursive";
    ctx.textBaseline = "middle";
    ctx.fillText(typedName || "Signature", 16, c.height / 2);
    onChange?.(c.toDataURL("image/png"));
  };

  return (
    <div className="space-y-3" data-testid="signature-pad">
      <div className="flex gap-2">
        <Button
          type="button"
          variant={mode === "draw" ? "default" : "outline"}
          size="sm"
          onClick={() => setMode("draw")}
          data-testid="sig-mode-draw"
        >
          Draw
        </Button>
        <Button
          type="button"
          variant={mode === "type" ? "default" : "outline"}
          size="sm"
          onClick={() => setMode("type")}
          data-testid="sig-mode-type"
        >
          Type
        </Button>
        <Button type="button" variant="ghost" size="sm" onClick={clear} data-testid="sig-clear">
          Clear
        </Button>
      </div>
      {mode === "type" && (
        <div className="flex gap-2">
          <input
            value={typedName}
            onChange={(e) => setTypedName(e.target.value)}
            placeholder="Type your signature"
            className="flex-1 bg-background border border-input rounded-md px-3 py-2 text-sm"
            data-testid="sig-type-input"
          />
          <Button type="button" size="sm" onClick={applyTyped} data-testid="sig-apply">Apply</Button>
        </div>
      )}
      <canvas
        ref={canvasRef}
        width={500}
        height={140}
        className="k-signature w-full"
        onMouseDown={start}
        onMouseMove={draw}
        onMouseUp={end}
        onMouseLeave={end}
        onTouchStart={start}
        onTouchMove={draw}
        onTouchEnd={end}
      />
    </div>
  );
}
